import React, {Component} from 'react';
import Formsy from 'formsy-react';
import { FormsySelect, FormsyText } from 'formsy-material-ui/lib';
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';
import Paper from 'material-ui/Paper';
import Divider from 'material-ui/Divider';
import Core from './Core';
import update from 'immutability-helper';
import MediaQuery from 'react-responsive';
import prostate from '../images/prostate.jpg';

class Form extends Component {

  props: Props;

  state: {
    canSubmit: boolean;
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      canSubmit: false,
      values: {
        tumor_positive: {
          lla: '',
          la: '',
          ra: '',
          rla: '',
          llm: '',
          lm: '',
          rm: '',
          rlm: '',
          llb: '',
          lb: '',
          rb: '',
          rlb: '',
        },
        overall_gleason: {
          lla: '',
          la: '',
          ra: '',
          rla: '',
          llm: '',
          lm: '',
          rm: '',
          rlm: '',
          llb: '',
          lb: '',
          rb: '',
          rlb: '',
        }
      }
    };
  }
  enableButton = () => {
    if (!this.state.canSubmit) {
      this.setState({canSubmit: true});
    }
  }

  disableButton = () => {
    if (this.state.canSubmit) {
      this.setState({canSubmit: false});
    }
  }

  notifyFormError = (data: Object) => {
    console.error('Form error:', data);
  }

  handleChange = (name, type, value) => {
    let nextValues = this.state.values, types = [type];
    if (value === '0' || value === '') {
      if (type === 'tumor_positive') {
        types.push('overall_gleason');
      } else {
        types.push('tumor_positive');
      }
    }
    for (let type of types) {
      nextValues = update(nextValues, {
        [type]: {
          [name]: {
            $set: value
          }
        }
      });
    }
    this.setState({
      values: nextValues
    });
  }

  render() {
      return (
      <Formsy.Form
        onValid={this.enableButton}
        onInvalid={this.disableButton}
        onValidSubmit={this.props.handleSubmit}
        onInvalidSubmit={this.notifyFormError}
      >
        <Paper className="prostate-form" zDepth={1}>
          <h3>% Tumor Positive</h3>
          <Divider />
          <div className="node-grid">
              <img src={prostate} className="prostate" alt="prostate" />
          <Core
            type="tumor_positive"
            name="llb"
            value={this.state.values.tumor_positive.llb}
            onChange={this.handleChange}
          />
          <Core
            type="tumor_positive"
            name="lb"
            value={this.state.values.tumor_positive.lb}
            onChange={this.handleChange}
          />
          <Core
            type="tumor_positive"
            name="rb"
            value={this.state.values.tumor_positive.rb}
            onChange={this.handleChange}
          />
          <Core
            type="tumor_positive"
            name="rlb"
            value={this.state.values.tumor_positive.rlb}
            onChange={this.handleChange}
          />
          <Core
            type="tumor_positive"
            name="llm"
            value={this.state.values.tumor_positive.llm}
            onChange={this.handleChange}
          />
          <Core
            type="tumor_positive"
            name="lm"
            value={this.state.values.tumor_positive.lm}
            onChange={this.handleChange}
          />
          <Core
            type="tumor_positive"
            name="rm"
            value={this.state.values.tumor_positive.rm}
            onChange={this.handleChange}
          />
          <Core
            type="tumor_positive"
            name="rlm"
            value={this.state.values.tumor_positive.rlm}
            onChange={this.handleChange}
          />
          <Core
            type="tumor_positive"
            name="lla"
            value={this.state.values.tumor_positive.lla}
            onChange={this.handleChange}
          />
          <Core
            type="tumor_positive"
            name="la"
            value={this.state.values.tumor_positive.la}
            onChange={this.handleChange}
          />
          <Core
            type="tumor_positive"
            name="ra"
            value={this.state.values.tumor_positive.ra}
            onChange={this.handleChange}
          />
          <Core
            type="tumor_positive"
            name="rla"
            value={this.state.values.tumor_positive.rla}
            onChange={this.handleChange}
          />
        </div>
    </Paper>
    <Paper
      className="prostate-form"
      zDepth={1}
    >
      <h3>Overall Gleason</h3>
      <Divider />
      <div className="node-grid">
        <img src={prostate} className="prostate" alt="prostate" />
        <Core
          type="overall_gleason"
          name="llb"
          value={this.state.values.overall_gleason.llb}
          onChange={this.handleChange}
        />
        <Core
          type="overall_gleason"
          name="lb"
          value={this.state.values.overall_gleason.lb}
          onChange={this.handleChange}
        />
        <Core
          type="overall_gleason"
          name="rb"
          value={this.state.values.overall_gleason.rb}
          onChange={this.handleChange}
        />
        <Core
          type="overall_gleason"
          name="rlb"
          value={this.state.values.overall_gleason.rlb}
          onChange={this.handleChange}
        />
        <Core
          type="overall_gleason"
          name="llm"
          value={this.state.values.overall_gleason.llm}
          onChange={this.handleChange}
        />
        <Core
          type="overall_gleason"
          name="lm"
          value={this.state.values.overall_gleason.lm}
          onChange={this.handleChange}
        />
        <Core
          type="overall_gleason"
          name="rm"
          value={this.state.values.overall_gleason.rm}
          onChange={this.handleChange}
        />
        <Core
          type="overall_gleason"
          name="rlm"
          value={this.state.values.overall_gleason.rlm}
          onChange={this.handleChange}
        />
        <Core
          type="overall_gleason"
          name="lla"
          value={this.state.values.overall_gleason.lla}
          onChange={this.handleChange}
        />
        <Core
          type="overall_gleason"
          name="la"
          value={this.state.values.overall_gleason.la}
          onChange={this.handleChange}
        />
        <Core
          type="overall_gleason"
          name="ra"
          value={this.state.values.overall_gleason.ra}
          onChange={this.handleChange}
        />
        <Core
          type="overall_gleason"
          name="rla"
          value={this.state.values.overall_gleason.rla}
          onChange={this.handleChange}
        />
      </div>
    </Paper>
    <MediaQuery print={false}>
      {(matches) => {
        let style = {}, button = null;
        if (matches) {
          style = {width: "21%", margin: "2%"};
          button = (<RaisedButton
                      type="submit"
                      label="Submit"
                      style={style}
                      disabled={!this.state.canSubmit}
                    />);
        } else {
          style = {width: "31%", margin: "1%"};
        }
        let selectStyle = style;
        selectStyle.verticalAlign = "bottom";

        return (
          <div>
            <FormsySelect
              name="stage"
              required
              floatingLabelText="Clinical stage"
              style={selectStyle}
              >
             <MenuItem value="T1a" primaryText="T1a" />
             <MenuItem value="T1b" primaryText="T1b" />
             <MenuItem value="T1c" primaryText="T1c" />
             <MenuItem value="T2a" primaryText="T2a" />
             <MenuItem value="T2b" primaryText="T2b" />
             <MenuItem value="T2c" primaryText="T2c" />
             <MenuItem value="T3a" primaryText="T3a" />
             <MenuItem value="T3b" primaryText="T3b" />
             <MenuItem value="T4" primaryText="T4" />
           </FormsySelect>
           <FormsyText
             name="age"
             required
             validations={{
               isInt: true,
               isValueInRange: {
                 min: 20,
                 max: 100
               }
             }}
             validationErrors={{
               isInt: 'Only integers allowed in this field',
               isValueInRange: 'Enter a number in the allowed range'
             }}
             hintText="20~100"
             floatingLabelText="Age"
             fullWidth={true}
             style={style}
           />
          <FormsyText
            name="psa"
            required
            validations={{
              isFloat: true,
              isValueInRange: {
                min: 0,
                max: 200
              },
              matchRegexp: /^\d{0,3}(?:\.\d)?$/,
            }}
            validationErrors={{
              isFloat: 'Only numbers allowed in this field',
              isValueInRange: 'Enter a number in the allowed range',
              matchRegexp: 'Max 1 decimal place allowed',
            }}
            hintText="0~200, max 1 decimal place"
            floatingLabelText="Total PSA (ng/mL)"
            style={style}
          />
          {button}
        </div>
        )
      }}
    </MediaQuery>
    </Formsy.Form>);
  }
}

export default Form;



/** WEBPACK FOOTER **
 ** ./src/Components/Form.js
 **/